/** Shown on the login screen — bump when shipping a new PWA build. */
export const PWA_BUILD_ID = 'v2.1';
